import { combineReducers } from "redux";
import loginSliceReducer from "../features/login/LoginSlice";
import appLoaderReducer from "../features/appLoader/appLoaderSlice";

export default combineReducers({
  loginSlice: loginSliceReducer,
  appLoaderSlice: appLoaderReducer,
});
